/* 
* <license header>
*/

import React, { useEffect, useState } from 'react'
import { fetchItems, fetchStats, postVote } from './votingApi'

// --- Living Link (from sneaks-voting app/page.tsx) — disabled; uncomment when a server runs on :5000 ---
// Add `useRef` to the React import above when you enable this block.
// const LIVING_LINK_SERVER = 'http://localhost:5000'
// const SCREENSHOT_DEBOUNCE_MS = 500
// const screenshotDebounceRef = useRef(null)
// useEffect(() => () => {
//   if (screenshotDebounceRef.current) clearTimeout(screenshotDebounceRef.current)
// }, [])
// In handleVote, after a successful vote (after setStats), add:
//   if (screenshotDebounceRef.current) clearTimeout(screenshotDebounceRef.current)
//   screenshotDebounceRef.current = setTimeout(() => {
//     screenshotDebounceRef.current = null
//     const summaryUrl = `${window.location.origin}${window.location.pathname}${window.location.search}#/website/summary`
//     fetch(`${LIVING_LINK_SERVER}/api/screenshot-debounce`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ url: summaryUrl })
//     })
//       .then((r) => r.json().catch(() => r.text()))
//       .then((data) => console.log('screenshot-debounce response:', data))
//       .catch((err) => console.log('screenshot-debounce error:', err))
//   }, SCREENSHOT_DEBOUNCE_MS)
// --- end Living Link ---

export default function VotePage () {
  const [items, setItems] = useState([])
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [voting, setVoting] = useState(null)

  useEffect(() => {
    let cancelled = false
    async function load () {
      try {
        const [itemsRes, statsRes] = await Promise.all([fetchItems(), fetchStats()])
        if (cancelled) return
        if (Array.isArray(itemsRes)) setItems(itemsRes)
        if (statsRes && statsRes.items) setStats(statsRes)
      } catch (e) {
        console.error(e)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    load()
    return () => { cancelled = true }
  }, [])

  async function handleVote (itemId) {
    setVoting(itemId)
    try {
      await postVote(itemId)
      const data = await fetchStats()
      if (data && data.items) {
        setStats({ ...data, items: [...data.items] })
      }

      // Living Link: debounced screenshot trigger — see commented block at top of file.
      // if (screenshotDebounceRef.current) clearTimeout(screenshotDebounceRef.current)
      // screenshotDebounceRef.current = setTimeout(() => {
      //   screenshotDebounceRef.current = null
      //   const summaryUrl = `${window.location.origin}${window.location.pathname}${window.location.search}#/website/summary`
      //   fetch(`${LIVING_LINK_SERVER}/api/screenshot-debounce`, {
      //     method: 'POST',
      //     headers: { 'Content-Type': 'application/json' },
      //     body: JSON.stringify({ url: summaryUrl })
      //   })
      //     .then((r) => r.json().catch(() => r.text()))
      //     .then((data) => console.log('screenshot-debounce response:', data))
      //     .catch((err) => console.log('screenshot-debounce error:', err))
      // }, SCREENSHOT_DEBOUNCE_MS)
    } catch (e) {
      console.error(e)
    } finally {
      setVoting(null)
    }
  }

  if (loading) {
    return (
      <div className="wv-loading">
        <p>Loading…</p>
      </div>
    )
  }

  const votesByItem = new Map((stats && stats.items ? stats.items : []).map((i) => [i.id, i.votes]))

  return (
    <>
      <p className="wv-intro">
        Vote for which city should get an extra show on the tour. You can vote for any city as many times as
        you like — we&apos;re gauging fan interest to update the poster live.
      </p>
      <section>
        <h2 className="wv-section-title">Vote for the next tour city</h2>
        <ul className="wv-grid">
          {items.map((item) => {
            const votes = votesByItem.get(item.id) ?? 0
            const isVoting = voting === item.id
            return (
              <li key={item.id} className="wv-card">
                <div className="wv-card-body">
                  <p className="wv-card-name">{item.name}</p>
                  <p className="wv-card-desc">{item.description}</p>
                  <p className="wv-card-venue">{item.venue}</p>
                  <p className="wv-card-votes">
                    {votes} {votes === 1 ? 'vote' : 'votes'}
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => handleVote(item.id)}
                  disabled={isVoting}
                  className="wv-btn-vote"
                >
                  {isVoting ? '…' : 'Vote'}
                </button>
              </li>
            )
          })}
        </ul>
      </section>
    </>
  )
}
